import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  background-color: black;
  position: relative;
  img {
	width: 20%;
	height: 100%;    
	justify-content: center;
	display: flex;
	 margin: 0 auto;
  }
  &:after {
		border-bottom: 1px solid blue;
		width: 1000px;		 
	 }
`;

export const Footer = styled.div`
  width: 100%;
  background-color: black;
  color: #F4E8B5;
  text-align: center;
  height: 100px;
  a {
	color: #F4E8B5;
	cursor: pointer;
  }
`;


export const Container = styled.div`
	  background-color: black;
	  height: auto;

  img {
	width: 100%;
	height: 100%;    
	justify-content: flex-start;
	display: flex;
	opacity: .7;
	filter: alpha(opacity=50);
	transition: all 1s;	
	position: absolute;
	&.imgBox {
		right: 10px;
	}
  }
  .main {
	  position: relative;
	  opacity: 0.8;
	  height: 88vh;    
  }
  p {
	  &.title {
		text-align: center;
		transform: translate(0, 20px);
		margin: 0;
		font-size: 60px;
		font-family: Helvetica, sans-serif;
		width: 100%;
		max-width: 850px;
		margin: 0 auto;
		border-radius: 8px;
		color: #F4E8B5;
		span {
			font-weight: bold;
			
		}
		h4 {
			font-size: 12px;
			line-height: 30px;
		}
	  }
  }
  .icons {
		max-width: 600px;
		margin: 50px auto 0;
		justify-content: space-between;
		display: flex;
  }
`;

export const Box = styled.div`
  width: 60%;
  height: 300px;
  background-color: red;
  margin: 0 auto;
  border-radius: 8px;
`;

export const StyledBox = styled.div`
  display: flex;
  width: 100%;
  margin: 20px auto 20px;
  border-radius: 8px;
  overflow: hidden;
  h4 {
	  &.article{
		/* max-width: 600px; */
		padding: 0 100px;
	  }
	  &.form {
	  }
  }
`;

export const Deco = styled.div`
  border-bottom: 1px solid #F4E8B5;
`;

export const ImgBox = styled.div`
width: 60%;
img {
	width: 25%;
	height: 25%;
	opacity: 1;
}
   
`;


